// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datepicker[data-v-3be099ea] .vdp-datepicker__calendar {\n  --border-opacity: 1;\n  border-color: #1A7BEE;\n  border-color: rgba(26, 123, 238, var(--border-opacity));\n  border-radius: 0.25rem;\n}\n.datepicker[data-v-3be099ea] .vdp-datepicker__calendar .adjustBorder, .datepicker[data-v-3be099ea] .vdp-datepicker__calendar .datePickerHeight {\n  height: 40px;\n  border: 0.5px solid rgba(168, 174, 184, 0.5);\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
